// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WwwRouteRouteImport } from './routes/_www/route'
import { Route as PrintFlyerRouteImport } from './routes/print/flyer'
import { Route as WwwIndexRouteImport } from './routes/_www/index'
import { Route as WwwImpressumRouteImport } from './routes/_www/impressum'
import { Route as WwwHistorieRouteImport } from './routes/_www/historie'
import { Route as WwwDatenschutzRouteImport } from './routes/_www/datenschutz'
import { Route as WwwBuchenIndexRouteImport } from './routes/_www/buchen/index'
import { Route as WwwBuchenGruppeRouteImport } from './routes/_www/buchen/gruppe'
import { Route as WwwAngeboteBowlingIndexRouteImport } from './routes/_www/angebote/bowling/index'
import { Route as WwwAngebote3dSchwarzlichtMinigolfIndexRouteImport } from './routes/_www/angebote/3d-schwarzlicht-minigolf/index'
import { Route as WwwAngeboteBowlingGalerieRouteImport } from './routes/_www/angebote/bowling/galerie'
import { Route as WwwAngebote3dSchwarzlichtMinigolfGalerieRouteImport } from './routes/_www/angebote/3d-schwarzlicht-minigolf/galerie'

const WwwRouteRoute = WwwRouteRouteImport.update({
            id: '/_www',getParentRoute: () => rootRouteImport
          })
const PrintFlyerRoute = PrintFlyerRouteImport.update({
            id: '/print/flyer',path: '/print/flyer',getParentRoute: () => rootRouteImport
          })
const WwwIndexRoute = WwwIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WwwRouteRoute
          })
const WwwImpressumRoute = WwwImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => WwwRouteRoute
          })
const WwwHistorieRoute = WwwHistorieRouteImport.update({
            id: '/historie',path: '/historie',getParentRoute: () => WwwRouteRoute
          })
const WwwDatenschutzRoute = WwwDatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => WwwRouteRoute
          })
const WwwBuchenIndexRoute = WwwBuchenIndexRouteImport.update({
            id: '/buchen/',path: '/buchen/',getParentRoute: () => WwwRouteRoute
          })
const WwwBuchenGruppeRoute = WwwBuchenGruppeRouteImport.update({
            id: '/buchen/gruppe',path: '/buchen/gruppe',getParentRoute: () => WwwRouteRoute
          })
const WwwAngeboteBowlingIndexRoute = WwwAngeboteBowlingIndexRouteImport.update({
            id: '/angebote/bowling/',path: '/angebote/bowling/',getParentRoute: () => WwwRouteRoute
          })
const WwwAngebote3dSchwarzlichtMinigolfIndexRoute = WwwAngebote3dSchwarzlichtMinigolfIndexRouteImport.update({
            id: '/angebote/3d-schwarzlicht-minigolf/',path: '/angebote/3d-schwarzlicht-minigolf/',getParentRoute: () => WwwRouteRoute
          })
const WwwAngeboteBowlingGalerieRoute = WwwAngeboteBowlingGalerieRouteImport.update({
            id: '/angebote/bowling/galerie',path: '/angebote/bowling/galerie',getParentRoute: () => WwwRouteRoute
          })
const WwwAngebote3dSchwarzlichtMinigolfGalerieRoute = WwwAngebote3dSchwarzlichtMinigolfGalerieRouteImport.update({
            id: '/angebote/3d-schwarzlicht-minigolf/galerie',path: '/angebote/3d-schwarzlicht-minigolf/galerie',getParentRoute: () => WwwRouteRoute
          })





const WwwRouteRouteChildren = {
  WwwDatenschutzRoute: WwwDatenschutzRoute,WwwHistorieRoute: WwwHistorieRoute,WwwImpressumRoute: WwwImpressumRoute,WwwIndexRoute: WwwIndexRoute,WwwBuchenGruppeRoute: WwwBuchenGruppeRoute,WwwBuchenIndexRoute: WwwBuchenIndexRoute,WwwAngebote3dSchwarzlichtMinigolfGalerieRoute: WwwAngebote3dSchwarzlichtMinigolfGalerieRoute,WwwAngeboteBowlingGalerieRoute: WwwAngeboteBowlingGalerieRoute,WwwAngebote3dSchwarzlichtMinigolfIndexRoute: WwwAngebote3dSchwarzlichtMinigolfIndexRoute,WwwAngeboteBowlingIndexRoute: WwwAngeboteBowlingIndexRoute
}

const WwwRouteRouteWithChildren = WwwRouteRoute._addFileChildren(WwwRouteRouteChildren)

const rootRouteChildren = {
  WwwRouteRoute: WwwRouteRouteWithChildren,PrintFlyerRoute: PrintFlyerRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)